export const ROOM_SETTING_EVENT = 'RoomSettingEvent';
